export default () => {
  return localStorage.getItem('token')
}
